var map = {
	"./views/goldSun/goldSun_router": [
		9890,
		9
	],
	"./views/goldSun/goldSun_router.vue": [
		9890,
		9
	],
	"./views/goldSun/loading": [
		6028,
		3
	],
	"./views/goldSun/loading.json": [
		6028,
		3
	],
	"./views/goldSun/road-list": [
		5054,
		9
	],
	"./views/goldSun/road-list.vue": [
		5054,
		9
	],
	"./views/goldSun/summary_router": [
		3503,
		9
	],
	"./views/goldSun/summary_router.vue": [
		3503,
		9
	]
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var ids = map[req], id = ids[0];
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9331;
module.exports = webpackAsyncContext;